import { observer } from 'mobx-react';

import { Button, ButtonModifiers, ButtonTheme } from '@components/Button';
import { translate } from '@chaika/i18n/helper';

interface Props {
    buttonParams: ButtonParams;
}

export interface ButtonParams {
    label?: string;
    dataTest?: string;
    theme?: ButtonTheme;
    disabled?: boolean;
    onClick(): void;
}

export const ControlButton = observer(({ buttonParams }: Props) => {
    return (
        <Button
            modifiers={[ButtonModifiers.Big]}
            theme={buttonParams.theme ?? ButtonTheme.Primary}
            dataTest={buttonParams.dataTest}
            disabled={buttonParams.disabled}
            onClick={buttonParams.onClick}
            label={buttonParams.label ?? translate('add')}
        />
    );
});
